import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class CreditsPartIIIF8936SchAService {
  constructor(private http: HttpClient) {}

  private toUrlEncoded(params: any): string {
    const body = new URLSearchParams();
    Object.keys(params).forEach((k) => {
      if (params[k] !== undefined && params[k] !== null) {
        body.set(k, String(params[k]));
      }
    });
    return body.toString();
  }

  private postUrlEncoded(url: string, params: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post<any>(url, this.toUrlEncoded(params), { headers, withCredentials: true });
  }

  loadJsonObject(baseUrl: string, params: any): Observable<any> {
    return this.postUrlEncoded(`${baseUrl}/loadJsonObject`, params);
  }

  saveSchdA(
    baseUrl: string,
    clobData: any,
    clobSettings: any,
    globalService: any,
    filterParams: any
  ): Observable<any> {
    const url = baseUrl + '/saveJsonObject?action_code=mvxxgb';
    let params: any = _.merge({}, globalService?.globalParams || {}, filterParams);
    params = _.extend({ clob_data: JSON.stringify(clobData) }, params);
    params = _.extend({ clob_settings: JSON.stringify(clobSettings) }, params);
    params.process_name = 'credit-forms-grid-save';
    return this.postUrlEncoded(url, params);
  }

  deleteStageRecord(baseUrl: string, stageKey: any, ssoId: any): Observable<any> {
    const url = baseUrl + '/saveJsonObject?action_id=33412';
    return this.postUrlEncoded(url, {
      action_code: 'h8yl80',
      sso_id: ssoId,
      stage_key: stageKey
    });
  }
}
